import ApiService from './api.service';
import LanguageService from './language.service';
import {
  SolrNewsTypeName, SolrExhibitorTypeName, SolrProductTypeName, SolrFairTypeName
} from '@/common/Utility';
import { SOLR_URL } from './config';

/* eslint-disable no-unused-vars */
const SolrService = {
  getAutocompleteSuggetions(
    query,
    limitedFairEvents,
    fairGroups = [],
    types = [],
    categories = [],
    travelDestinations = [],
    halls = []
  ) {
    const cfq = this.getSuggestContext(
      limitedFairEvents,
      fairGroups,
      types,
      categories,
      travelDestinations,
      halls
    );
    const escapedQuery = encodeURIComponent(query);
    return ApiService.post(`${SOLR_URL}/core_${LanguageService.getCurrentTYPO3Language()}/suggest?`, `suggest.q=${escapedQuery}&suggest.cfq=${cfq}`);
  },
  getData(
    query = '*:*',
    limitedFairEventsConfig,
    typeFilterValue,
    categoryFilterValue,
    showFavourites,
    favouriteItems,
    travelDestinationFilterValue,
    fairGroupsFilterValue,
    hallFilterValue,
    offset = 0,
    rows = 25,
    sorting = 'asc',
    getTopOfTheList = false,
    ) {

    const fqFromSuggestContext = this.getSuggestContext(
      limitedFairEventsConfig,
      fairGroupsFilterValue,
      typeFilterValue,
      categoryFilterValue,
      travelDestinationFilterValue,
      hallFilterValue
    );

    const escapedQuery = encodeURIComponent(query);
    const typeArray = [];
    // const limitedFairEventsArray = [];
    const fairGroupsArray = [];
    const categoryArray = [];
    const travelDestinationArray = [];
    const hallArray = [];
    let favouriteArray = [];

    let tempTypeString = '';
    let limitedFairEventsString = '';
    let limitedFairEventsMultiValueFieldString;
    let categoryString = '';
    let travelDestinationString = '';
    let favouriteString = '';
    let fairGroupsString = '';
    let fairGroupsStringMultiValue = '';
    let hallString = '';

    /* build query for filter request, if there are filter already set */
    if (fairGroupsFilterValue !== null) {
      for (let i = 0; i < fairGroupsFilterValue.length; i += 1) {
        fairGroupsArray.push(fairGroupsFilterValue[i].id);
      }
      if (fairGroupsArray.length > 0) {
        fairGroupsString = `(fair_id:${fairGroupsArray.join(' OR fair_id:')})`;
        fairGroupsStringMultiValue = `(fair_ids:${fairGroupsArray.join(' OR fair_ids:')})`;
      }
    }
    if (typeFilterValue !== null) {
      for (let i = 0; i < typeFilterValue.length; i += 1) {
        typeArray.push(typeFilterValue[i].id);
      }
      if (typeArray.length > 0) {
        tempTypeString = `(type:${typeArray.join(' OR type:')})`;
      }
    }


    if (categoryFilterValue !== null) {
      for (let i = 0; i < categoryFilterValue.length; i += 1) {
        categoryArray.push(categoryFilterValue[i].id);
      }
      if (categoryArray.length > 0) {
        categoryString = `(av_categories:\\"${categoryArray.join('\\" OR av_categories:\\"')}\\")`;
      }
    }

    if (travelDestinationFilterValue !== null) {
      for (let i = 0; i < travelDestinationFilterValue.length; i += 1) {
        travelDestinationArray.push(travelDestinationFilterValue[i].id);
      }
      if (travelDestinationArray.length > 0) {
        travelDestinationString = `(av_travel_destinations:\\"${travelDestinationArray.join('\\" OR av_travel_destinations:\\"')}\\")`;
      }
    }

    if (hallFilterValue !== null) {
      for (let i = 0; i < hallFilterValue.length; i += 1) {
        hallArray.push(hallFilterValue[i].id);
      }
      if (hallArray.length > 0) {
        hallString = `(av_halls:\\"${hallArray.join('\\" OR av_halls:\\"')}\\")`;
      }
    }

    if (showFavourites) {
      favouriteArray = favouriteItems;
      for (let i = 0; i < favouriteArray.length; i += 1) {
        favouriteString = `(id:${favouriteArray.join(' OR id:')})`;
      }
    } else {
      favouriteString = '';
    }

    /* limit searched fairEvents by plugin configuration if there is no filter set */
    if (limitedFairEventsString === '') {
      /* empty config => all fairEvents */
      const limitedFairEvents = JSON.parse(limitedFairEventsConfig);
      if (limitedFairEvents.length > 0) {
        limitedFairEventsString = `(fair_id:${limitedFairEvents.join(' OR fair_id:')})`;
        limitedFairEventsMultiValueFieldString = `(fair_ids:${limitedFairEvents.join(' OR fair_ids:')})`;
      } else {
        limitedFairEventsString = '*:*';
        limitedFairEventsMultiValueFieldString = '*:*';
      }
    }

    // eslint-disable-next-line
    let childFilterString = limitedFairEventsString;
    const encodedFairFilterMultiValue = limitedFairEventsMultiValueFieldString ? limitedFairEventsMultiValueFieldString.replace(/&/g, '%26') : '';
    const encodedFairFilterMultiValueString = encodedFairFilterMultiValue ? ` AND (${encodedFairFilterMultiValue})` : '';
    const typeString = `OR (type:${SolrProductTypeName}${encodedFairFilterMultiValueString}) OR (type:${SolrNewsTypeName}${encodedFairFilterMultiValueString})`;
    const flTypeString = `type:${SolrExhibitorTypeName} OR type:${SolrProductTypeName} OR type:${SolrNewsTypeName}`;
    childFilterString += categoryString ? ` AND ${categoryString}` : '';
    const favouriteFilterString = favouriteString ? ` ${favouriteString}` : '';
    const fairGroupsFilterString = fairGroupsString ? ` ${fairGroupsString}` : '';
    const travelDestinationFilterString = travelDestinationString ? ` ${travelDestinationString}` : '';
    const hallFilterString = hallString ? `${hallString}` : '';
    const fairGroupsFilterMultiValueString = fairGroupsStringMultiValue ? ` ${fairGroupsStringMultiValue}` : '';

    /* encode & with %26 */
    const encodedChildFilterString = childFilterString.replace(/&/g, '%26');
    const encodedFairFilter = limitedFairEventsString.replace(/&/g, '%26');
    const encodedCategoryFilter = categoryString.replace(/&/g, '%26');
    const encodedTravelDestinationFilter = travelDestinationFilterString.replace(/&/g, '%26');
    const encodedHallFilter = hallFilterString.replace(/&/g, '%26');
    const encodedTypeFilterString = tempTypeString.replace(/&/g, '%26');
    const encodedFavouriteFilterString = favouriteFilterString.replace(/&/g, '%26');
    const encodedFairGroupsFilter = fairGroupsFilterString.replace(/&/g, '%26');
    const encodedFairGroupsFilterMultiValue = fairGroupsFilterMultiValueString.replace(/&/g, '%26');
    const encodedFairGroupsFilterMultiValueString = encodedFairGroupsFilterMultiValue ? ` AND (${encodedFairGroupsFilterMultiValue})` : '';

    const fl = `fl=*,contacts:[json],av_booths:[json],av_badges:[json],av_exhibitor_object:[json],av_teaser:[json],av_products:[json],av_news:[json],exhibitor_social_media:[json],[child parentFilter="${flTypeString}" childFilter="${encodedChildFilterString}"]`;
    const fqFair = encodedFairFilter ? `&fq=({!parent which=type:${SolrExhibitorTypeName} v="${encodedFairFilter}"}) ${typeString}` : '';
    const fqCategory = encodedCategoryFilter ? `&fq={!tag=av_categories}({!parent which=type:${SolrExhibitorTypeName} v="${encodedCategoryFilter}"})` : '';
    const fqTravelDestination = encodedTravelDestinationFilter ? `&fq={!tag=av_travel_destinations}({!parent which=type:${SolrExhibitorTypeName} v="${encodedTravelDestinationFilter}"})` : '';
    const fqHall = encodedHallFilter ? `&fq={!tag=av_halls}({!parent which=type:${SolrExhibitorTypeName} v="${encodedHallFilter}"})` : '';
    const fqFavourites = encodedFavouriteFilterString ? `&fq={!tag=favourites}(${encodedFavouriteFilterString})` : '';
    const fqType = encodedTypeFilterString ? `&fq={!tag=type}${encodedTypeFilterString}` : '';
    const fqFairGroups = encodedFairGroupsFilter ? `&fq={!tag=fair_groups}({!parent which=type:${SolrExhibitorTypeName} v="${encodedFairGroupsFilter}"}) OR (type:${SolrNewsTypeName}${encodedFairGroupsFilterMultiValueString}) OR (type:${SolrProductTypeName}${encodedFairGroupsFilterMultiValueString})` : '';
    let fqTopOfTheList = '';

    if (getTopOfTheList) {
      fqTopOfTheList = '&fq=av_top_of_the_list:true';
    }

    // eslint-disable-next-line
    // const excludeTags = 'av_categories,favourites,query,type,av_travel_destinations,fair_groups,av_halls';
    const excludeTags = 'facet,query,favourites';
    const jsonFacet = {
      categories: {
        type: 'terms',
        field: 'av_categories',
        limit: -1,
        sort: {
          index: 'asc',
        },
        domain: {
          blockChildren: `type:${SolrExhibitorTypeName}`,
          /* remove escape backslashes */
          filter: limitedFairEventsString.replace(/\\"/g, '"'),
          excludeTags,
        },
      },
      type: {
        type: 'terms',
        field: 'type',
        limit: -1,
        domain: {
          excludeTags,
        },
      },
      travel_destination: {
        type: 'terms',
        field: 'av_travel_destinations',
        limit: -1,
        sort: {
          index: 'asc',
        },
        domain: {
          blockChildren: `type:${SolrExhibitorTypeName}`,
          filter: limitedFairEventsString.replace(/\\"/g, '"'),
          excludeTags,
        },
      },
      hall: {
        type: 'terms',
        field: 'av_halls',
        limit: -1,
        sort: {
          index: 'asc',
        },
        domain: {
          blockChildren: `type:${SolrExhibitorTypeName}`,
          filter: `${limitedFairEventsString.replace(/\\"/g, '"')} AND -(av_halls:Undefiniert OR av_halls:Undefined)`,
          excludeTags,
        },
      },
    };
    let isNews = false;
    let isProduct = false;
    let isExhibitor = false;
    let emptyTypeFilter = true;
    let ignoreFilter = false;
    let hideNewsAndProducts = false;
    if (typeFilterValue) {
      [].forEach.call(typeFilterValue, (filterType) => {
        if (filterType.id === SolrNewsTypeName) {
          isNews = true;
          emptyTypeFilter = false;
        } else if (filterType.id === SolrProductTypeName) {
          isProduct = true;
          emptyTypeFilter = false;
        } else if (filterType.id === SolrExhibitorTypeName) {
          isExhibitor = true;
          emptyTypeFilter = false;
        }
      });
    }
    if (query.includes(`id:${SolrExhibitorTypeName}`)) {
      ignoreFilter = true;
    }
    if ((categoryFilterValue && categoryFilterValue.length)
      || (travelDestinationFilterValue && travelDestinationFilterValue.length)
      || (hallFilterValue && hallFilterValue.length)) {
      hideNewsAndProducts = true;
    }

    const jsonFacetString = JSON.stringify(jsonFacet);
    let fqSuggest = '{!tag=facet}';
    if (isNews && !isExhibitor && !ignoreFilter) {
      fqSuggest += `type:${SolrNewsTypeName}`;
    } else if (isProduct && !isExhibitor && !ignoreFilter) {
      if (isNews) {
        fqSuggest += ' OR ';
      }
      fqSuggest += `type:${SolrProductTypeName}`;
    } else {
      fqSuggest += `((av_suggest_context:(${fqFromSuggestContext}) AND type:${SolrExhibitorTypeName})${(isNews || emptyTypeFilter || ignoreFilter) && !hideNewsAndProducts ? ` OR type:${SolrNewsTypeName}` : ''}${(isProduct || emptyTypeFilter || ignoreFilter) && !hideNewsAndProducts ? ` OR type:${SolrProductTypeName}` : ''})`;
    }
    const queryComplete = `${fl}&fq=${fqSuggest}${fqFair}${fqFavourites}&fq=appKey:mkdb&sort=av_sort ${sorting}&start=${offset}&rows=${rows}&q=${escapedQuery}&json.facet=${jsonFacetString}${fqTopOfTheList}`;
    return ApiService.post(`${SOLR_URL}/core_${LanguageService.getCurrentTYPO3Language()}/select?`, queryComplete);
  },
  getCategories(fairUids) {
    if (fairUids.length === 0) {
      throw new Error('No FairUids were given');
    }

    const categoryQuery = `&fq=type:${SolrFairTypeName}&fq=appKey:mkdb&group=true&group.field=fair_id&q=*:*&fl=fair_id,av_categories_fair`;
    let fairUidQuery = '';
    let index = 0;
    fairUids.forEach((fairUid) => {
      if (index === 0) {
        fairUidQuery = `fair_id:${fairUid}`;
      } else {
        fairUidQuery += ` OR fair_id:${fairUid}`;
      }
      index += 1;
    });
    return ApiService.post(`${SOLR_URL}/core_${LanguageService.getCurrentTYPO3Language()}/select?`, `${categoryQuery}&fq=${fairUidQuery}`);
  },
  getExhibitorForNews(id) {
    return ApiService.get(`${SOLR_URL}/core_${LanguageService.getCurrentTYPO3Language()}/select?fl=title,av_logo&q=id:${id}&fq=appKey:mkdb`);
  },
  /* gets the latest 3 news for selected fairEvents in plugin */
  getLatestNews(limitedFairEventsConfig) {
    const newsType = `type:${SolrNewsTypeName}`;
    const sorting = 'date desc';
    const limit = 3;
    const limitedFairEvents = JSON.parse(limitedFairEventsConfig);
    const limitedFairEventsString = `(fair_ids:${limitedFairEvents.join(' OR fair_ids:')})`;

    return ApiService.get(`${SOLR_URL}/core_${LanguageService.getCurrentTYPO3Language()}/select?q=${newsType}&sort=${sorting}&rows=${limit}&fq=${limitedFairEventsString}`);
  },
  getSuggestContext(
    limitedFairEvents,
    fairGroups = [],
    types = [],
    categories = [],
    travelDestinations = [],
    halls = []
  ) {
    fairGroups = fairGroups === null ? [] : fairGroups;
    types = types === null ? [] : types;
    categories = categories === null ? [] : categories;
    travelDestinations = travelDestinations === null ? [] : travelDestinations;
    halls = halls === null ? [] : halls;
    let cfq = '';
    const re = new RegExp(/[^a-zA-Z0-9_.]/g);
    // eslint-disable-next-line
    limitedFairEvents = JSON.parse(limitedFairEvents);
    if (fairGroups.length === 0) {
      // eslint-disable-next-line
      fairGroups = [];
      for (let l = 0; l < limitedFairEvents.length; l += 1) {
        fairGroups.push({ id: limitedFairEvents[l] });
      }
    }
    if (fairGroups.length) {
      for (let i = 0; i < fairGroups.length; i += 1) {
        if (i !== 0) {
          cfq += ' OR (';
        } else {
          cfq += '((';
        }
        cfq += `fairId__${fairGroups[i].id.toString().replace(re, '').toLowerCase()}`;

        if (categories && categories.length) {
          for (let j = 0; j < categories.length; j += 1) {
            if (j === 0) {
              cfq += ' AND (';
            } else {
              cfq += ' OR ';
            }
            const theId = categories[j].id.replace(/\|/g, '__');
            cfq += `category__${fairGroups[i].id.toString().replace(re, '').toLowerCase()}__${theId.replace(re, '').toLowerCase()}`;
          }
          cfq += ')';
        }

        if (travelDestinations && travelDestinations.length) {
          for (let j = 0; j < travelDestinations.length; j += 1) {
            if (j === 0) {
              cfq += ' AND (';
            } else {
              cfq += ' OR ';
            }
            const theId = travelDestinations[j].id.replace(/\|/g, '__');
            cfq += `traveldestination__${fairGroups[i].id.toString().replace(re, '').toLowerCase()}__${theId.replace(re, '').toLowerCase()}`;
          }
          cfq += ')';
        }
        if (halls && halls.length) {
          for (let j = 0; j < halls.length; j += 1) {
            if (j === 0) {
              cfq += ' AND (';
            } else {
              cfq += ' OR ';
            }
            const theId = halls[j].id.replace(/\|/g, '__');
            cfq += `hall__${fairGroups[i].id.toString().replace(re, '').toLowerCase()}__${theId.replace(re, '').toLowerCase()}`;
          }
          cfq += ')';
        }
        cfq += `) OR (always__${fairGroups[i].id.toString().replace(re, '').toLowerCase()})`;
      }
      cfq += ')';
    }
    return cfq;
  },
};

export default SolrService;
